"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.multilevelCatalogDisplay = void 0;

var _EmptyBase = _interopRequireDefault(require("../base/EmptyBase.form"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var multilevelCatalogDisplay = [{
  weight: 2,
  type: 'textfield',
  input: true,
  key: 'catalogCode',
  label: 'Код справочника',
  defaultValue: '',
  validate: {
    required: true
  }
}, {
  type: 'checkbox',
  input: true,
  weight: 3,
  key: 'isWithAutoCheck',
  label: 'Автоматический выбор элементов',
  defaultValue: true,
  tooltip: 'При включенном чекбоксе при выборе элемента автоматически выбираются родительские и дочерние элементы'
}, {
  type: 'checkbox',
  input: true,
  weight: 4,
  key: 'isWithCode',
  label: 'Выводить с кодом',
  defaultValue: false
}, {
  type: 'select',
  input: true,
  weight: 5,
  key: 'sort',
  label: 'Сортировка',
  defaultValue: 'code',
  data: {
    values: [{
      label: 'По коду',
      value: 'code'
    }, {
      label: 'По значению',
      value: 'name'
    }]
  }
}];
exports.multilevelCatalogDisplay = multilevelCatalogDisplay;

function _default() {
  for (var _len = arguments.length, extend = new Array(_len), _key = 0; _key < _len; _key++) {
    extend[_key] = arguments[_key];
  }

  return _EmptyBase.default.apply(void 0, [[{
    key: 'display',
    components: multilevelCatalogDisplay
  }]].concat(extend));
}